/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OntologyTreeNode {
    getFixupPrototypeFunction() { return OntologyTreeNode.fixupPrototype; }

    static newInstance(model: Partial<OntologyTreeNode>): OntologyTreeNode {
        let obj = Object.assign(new OntologyTreeNode(), model);
        OntologyTreeNode.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OntologyTreeNode>): OntologyTreeNode {
        if (!model) return null;
        return OntologyTreeNode.newInstance(<OntologyTreeNode> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OntologyTreeNode) {
        if (!obj) return;

        models.OntologyTreeNode.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OntologyTreeNode): boolean {
        Object.setPrototypeOf(obj, OntologyTreeNode.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.children) {
            for (let val of this.children) {
                models.OntologyTreeNode.fixupPrototype(val);
            }
        }
    }

    /**
     * Stable node identifier
     */
    id: string;

    /**
     * Ontology type / node kind
     */
    type: string;

    /**
     * Display label
     */
    label: string;

    /**
     * Item count for this node, if applicable
     */
    count: number;

    /**
     * Whether this node has child nodes
     */
    has_children: boolean;

    /**
     * Child nodes
     */
    children: Array<models.OntologyTreeNode>;

}
